import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-terracotta text-white hover:bg-[#a65d33] shadow-lg shadow-terracotta/20 rounded-xl py-4 px-8 text-lg',
    secondary: 'bg-transparent border-2 border-navy text-navy hover:bg-navy/5 rounded-xl py-3 px-6 text-base'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    } else if (onClick) {
      onClick(e);
    } else {
      document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={handleClick} {...props} data-id="element-114">
      {children}
      {variant === 'primary' && <ArrowRight className="ml-2 h-5 w-5" data-id="element-115" />}
    </motion.button>;
}